export const ENABLED_COUNTRIES :Array<string> = [
    'india'.toLowerCase(),
    'UNITED STATES'.toLowerCase(),
    'UNITED ARAB EMIRATES'.toLowerCase(),
    'CANADA'.toLowerCase(),
    'UNITED KINGDOM'.toLowerCase(),
]